"use strict";

import Vue from "vue";
import axios from "axios";

/*let config = {
  baseURL: process.env.VUE_APP_API_URL || ""
};*/

let config = {
  baseURL: process.env.VUE_APP_API_URL + "/api/" || "",
  headers: {
    "Content-Type": "application/vnd.api+json"
  }
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
